import { gql } from '@/__generated__';

export const UPDATE_USER_PREFERRED_UNITS = gql(`#graphql
  mutation UpdateUserPreferredUnits($input: UpdateUserPreferencesPreferredUnitsInput!) {
    updateUserPreferencesPreferredUnits(input: $input) {
      id
      preferredUnits {
        id
        configurations {
          unit
          precision
          name
          deviceType
        }
      }
    }
  }
`);
